import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNotificationsCountKey } from '../../utils/keys';
export const useClearNotificationsCount = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(() => client.notifications.clearNotificationsCount(), {
        onMutate: () => {
            const notificationsCountKey = getNotificationsCountKey();
            queryClient.setQueriesData(notificationsCountKey, () => 0);
        },
        onSettled: () => {
            const notificationsCountKey = getNotificationsCountKey();
            queryClient.invalidateQueries(notificationsCountKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useClearNotificationsCount.js.map